import React, { useState, useEffect } from 'react';
import * as moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  Grid,
  Link,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import { useSnackbar } from 'notistack';
import { fetchCancelledPatientAppointments } from '../../../services/api';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// import AttachmentIcon from '@material-ui/icons/Attachment';
// import ApptAttachmentModal from './ApptAttachmentModal';

function PatientCancelAppt(props) {
  const {
    patientId,
    history,
    classes: { tableTitle, tableContainer, bookedAt },
  } = props;

  const enqueueSnackbar = useSnackbar();
  const pageLimit = 10;

  const [isLoading, setIsLoading] = useState(false);
  const [canAppts, setCancelledAppointments] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [attachment, setAttachment] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        fetchPatientAppointmentsInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        fetchPatientAppointmentsInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(true);
    })();
  }, [pageIndex]);

  const fetchPatientAppointmentsInfo = async () => {
    const appointments = await fetchCancelledPatientAppointments(
      patientId,
      pageLimit,
      pageIndex * 10
    );
    setCancelledAppointments(appointments);
    setIsLoading(false);
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  return isLoading ? (
    <div className={props.classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      <Grid item xs={12} className={tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={tableTitle}>Provider</TableCell>
              <TableCell className={tableTitle}>Location or Link</TableCell>
              <TableCell className={tableTitle}>Appointment Date</TableCell>
              <TableCell className={cx(tableTitle, bookedAt)}>
                Booked At
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {canAppts &&
              canAppts.map(cancelledAppointments => (
                <TableRow key={cancelledAppointments.id}>
                  <TableCell width="300px">
                    {`${cancelledAppointments &&
                      cancelledAppointments.tenancy &&
                      cancelledAppointments.tenancy.provider &&
                      cancelledAppointments.tenancy.provider.user
                        .firstName} ${cancelledAppointments &&
                      cancelledAppointments.tenancy &&
                      cancelledAppointments.tenancy.provider &&
                      cancelledAppointments.tenancy.provider.user.lastName}`}
                  </TableCell>
                  <TableCell width="300px">
                    {cancelledAppointments &&
                    cancelledAppointments.tenancy &&
                    cancelledAppointments.tenancy.virtualRoomUrl ? (
                      <Link
                        href={
                          cancelledAppointments &&
                          cancelledAppointments.tenancy &&
                          cancelledAppointments.tenancy.virtualRoomUrl
                        }
                      >
                        {cancelledAppointments &&
                          cancelledAppointments.tenancy &&
                          cancelledAppointments.tenancy.location}
                      </Link>
                    ) : (
                      cancelledAppointments &&
                      cancelledAppointments.tenancy &&
                      cancelledAppointments.tenancy.location
                    )}
                  </TableCell>
                  <TableCell width="300px">
                    {moment(cancelledAppointments && cancelledAppointments.time)
                      .tz('America/New_York')
                      .format('MM/DD/YYYY hh:mma z')}
                  </TableCell>
                  <TableCell className={bookedAt}>
                    {moment(
                      cancelledAppointments && cancelledAppointments.createdAt
                    )
                      .tz('America/New_York')
                      .format('MM/DD/YYYY hh:mma z')}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Grid>

      <div className={props.classes.pageTurners}>
        <IconButton disabled={pageIndex === 0}>
          <ArrowBackIosIcon
            style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageBack}
          />
        </IconButton>
        <IconButton>
          <ArrowForwardIosIcon
            style={{ opacity: canAppts.length < pageLimit ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageForward}
          />
        </IconButton>
      </div>
    </>
  );
}

PatientCancelAppt.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  tableTitle: {
    fontSize: '0.7rem',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  tableContainer: {
    overflowX: 'auto',
  },
});

export default withStyles(styles)(PatientCancelAppt);
